export default {
      id: "sort-usage",
      viewBox: "0 0 18 12",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#sort-usage",
      toString: function () {
        return this.url;
      }
    }